import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useRouter } from '../context/RouterContext';
import VocabularyTable from '../components/VocabularyTable';
import HierarchicalVocabulary from '../components/HierarchicalVocabulary';
import { UserInfo } from '../components/AppHeader';
import { VOCAB_CONFIG } from '../config/vocabConfig';

function VocabulariesPage() {
  const { user, logout } = useAuth();
  const { navigate } = useRouter();
  const [activeTab, setActiveTab] = useState('business-models');

  const tabs = Object.keys(VOCAB_CONFIG);

  return (
    <div className="vocab-viewer">
      <div className="container">
        <div className="header">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <div>
              <h1 style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>📊 Database Vocabularies</h1>
              <p>Explore dictionaries for controlled fields in the Credit Deals Tracker DB</p>
            </div>
            {user && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <button
                  onClick={() => navigate('/')}
                  style={{
                    padding: '8px 16px',
                    background: '#1f2937',
                    color: 'white',
                    border: '1px solid #1f2937',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: '500',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#374151';
                    e.target.style.borderColor = '#374151';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = '#1f2937';
                    e.target.style.borderColor = '#1f2937';
                  }}
                >
                  ← Back to Home
                </button>
                <div style={{ color: '#1f2937' }}>
                  <UserInfo user={user} showEmail={true} />
                </div>
                <button
                  onClick={logout}
                  style={{
                    padding: '8px 16px',
                    background: '#ef4444',
                    color: 'white',
                    border: '1px solid #ef4444',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: '500',
                    transition: 'all 0.2s'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = '#dc2626';
                    e.target.style.borderColor = '#dc2626';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = '#ef4444';
                    e.target.style.borderColor = '#ef4444';
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="info-box">
          <strong>💡 Quick Guide:</strong> Click column headers to sort • Click 📋 to copy entire columns • Use search to filter results instantly
        </div>

        <div className="tabs-container">
          <div className="tabs">
            {tabs.map(tab => (
              <button
                key={tab}
                className={`tab ${activeTab === tab ? 'active' : ''}`}
                onClick={() => setActiveTab(tab)}
              >
                {VOCAB_CONFIG[tab].title}
              </button>
            ))}
          </div>
        </div>

        <div className="tab-content">
          {VOCAB_CONFIG[activeTab].isHierarchical ? (
            <HierarchicalVocabulary config={VOCAB_CONFIG[activeTab]} />
          ) : (
            <VocabularyTable config={VOCAB_CONFIG[activeTab]} />
          )}
        </div>
      </div>
    </div>
  );
}

export default VocabulariesPage;
